import React from 'react';
import { Card } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
import { ChevronDown, Plus, AlertTriangle, Check } from 'lucide-react';
const TEAM_TABS = [{
  label: 'Shift Planner',
  path: ''
}, {
  label: 'Leave Timeline',
  path: 'leave'
}, {
  label: 'Team Directory',
  path: 'directory'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}];
const EMPLOYEES = [{
  id: 1,
  name: 'Antonina J.',
  role: 'Voda smene',
  initials: 'AJ',
  color: 'bg-green-500',
  hours: '40/40h',
  status: 'ok',
  schedule: [{
    type: 'day',
    time: '07-16',
    station: 'orange'
  }, {
    type: 'day',
    time: '07-16',
    station: 'pink'
  }, {
    type: 'day',
    time: '07-16',
    station: 'purple'
  }, {
    type: 'day',
    time: '07-16',
    station: 'orange'
  }, {
    type: 'day',
    time: '07-16',
    station: 'pink'
  }, {
    type: 'day',
    time: '07-16',
    station: 'purple'
  }, {
    type: 'off',
    time: 'Off',
    station: null
  }]
}, {
  id: 2,
  name: 'Jasmina N.',
  role: 'Voda smene',
  initials: 'JN',
  color: 'bg-red-500',
  hours: '40/40h',
  status: 'ok',
  schedule: [{
    type: 'night',
    time: '16-01',
    station: 'orange'
  }, {
    type: 'off',
    time: 'Off',
    station: null
  }, {
    type: 'night',
    time: '16-01',
    station: 'pink'
  }, {
    type: 'night',
    time: '16-01',
    station: 'purple'
  }, {
    type: 'special',
    time: '08-16',
    station: 'yellow',
    location: 'Đinđić'
  }, {
    type: 'night',
    time: '14-01',
    station: 'orange'
  }, {
    type: 'off',
    time: 'Off',
    station: null
  }]
}, {
  id: 3,
  name: 'Naveen',
  role: 'Kuvar',
  initials: 'N',
  color: 'bg-orange-500',
  hours: '40/40h',
  status: 'ok',
  schedule: [{
    type: 'day',
    time: '07-16',
    station: 'green'
  }, {
    type: 'day',
    time: '07-16',
    station: 'blue'
  }, {
    type: 'day',
    time: '07-16',
    station: 'teal'
  }, {
    type: 'day',
    time: '07-16',
    station: 'green'
  }, {
    type: 'day',
    time: '07-16',
    station: 'blue'
  }, {
    type: 'day',
    time: '07-16',
    station: 'teal'
  }, {
    type: 'off',
    time: 'Off',
    station: null
  }]
}, {
  id: 4,
  name: 'Nuran',
  role: 'Kuvar',
  initials: 'Nu',
  color: 'bg-purple-500',
  hours: '40/40h',
  status: 'ok',
  schedule: [{
    type: 'off',
    time: 'Off',
    station: null
  }, {
    type: 'night',
    time: '16-01',
    station: 'green'
  }, {
    type: 'night',
    time: '16-01',
    station: 'coral'
  }, {
    type: 'night',
    time: '16-01',
    station: 'gray'
  }, {
    type: 'night',
    time: '16-01',
    station: 'green'
  }, {
    type: 'night',
    time: '16-01',
    station: 'coral'
  }, {
    type: 'off',
    time: 'Off',
    station: null
  }]
}];
const DAYS = ['PON 15.12', 'UTO 16.12', 'SRE 17.12', 'ČET 18.12', 'PET 19.12', 'SUB 20.12', 'NED 21.12'];
const STAFF_COUNTS = [{
  count: 5,
  status: 'ok'
}, {
  count: 5,
  status: 'ok'
}, {
  count: 5,
  status: 'ok'
}, {
  count: 5,
  status: 'ok'
}, {
  count: 5,
  status: 'ok'
}, {
  count: 5,
  status: 'ok'
}, {
  count: 3,
  status: 'warning'
}];
function ShiftCell({
  shift
}: {
  shift: any;
}) {
  if (shift.type === 'off') {
    return <div className="h-full flex items-center justify-center text-text-muted text-sm" data-id="element-2335">
        Off
      </div>;
  }
  const bgColors = {
    day: 'bg-accent-success/20 text-accent-success border border-accent-success/30',
    night: 'bg-accent-primary/20 text-accent-primary border border-accent-primary/30',
    special: 'bg-accent-warning/20 text-accent-warning border border-accent-warning/30'
  };
  return <div className="flex flex-col items-center justify-center h-full py-2" data-id="element-2336">
      <div className={`px-3 py-1 rounded-lg text-sm font-medium ${bgColors[shift.type as keyof typeof bgColors]}`} data-id="element-2337">
        {shift.time}
      </div>
      {shift.location && <span className="text-[10px] text-text-secondary mt-1" data-id="element-2338">
          {shift.location}
        </span>}
    </div>;
}
function StationPill({
  type
}: {
  type: string | null;
}) {
  if (!type) return null;
  const colors = {
    orange: 'bg-orange-500',
    pink: 'bg-pink-500',
    purple: 'bg-purple-400',
    green: 'bg-green-400',
    blue: 'bg-blue-400',
    coral: 'bg-rose-400',
    teal: 'bg-teal-400',
    yellow: 'bg-yellow-400',
    gray: 'bg-gray-600'
  };
  const labels = {
    orange: 'Voda smene',
    pink: 'Kasa',
    purple: 'Pakovanje',
    green: 'Palačinke',
    blue: 'Salate',
    coral: 'Burgeri',
    teal: 'Giros',
    yellow: 'Special',
    gray: '[--]'
  };
  return <div className={`px-2 py-1 rounded text-[10px] font-medium text-white ${colors[type as keyof typeof colors]} w-full text-center truncate`} data-id="element-2339">
      {labels[type as keyof typeof labels]}
    </div>;
}
export function ShiftPlanner() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2340">
      {/* Top Bar */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-2341">
        <div data-id="element-2342">
          <h1 className="text-2xl font-bold text-text-primary flex items-center gap-2" data-id="element-2343">
            Team{' '}
            <span className="text-text-secondary text-lg font-normal" data-id="element-2344">
              8 members
            </span>
          </h1>
        </div>
        <div className="flex items-center gap-3" data-id="element-2345">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-2346">
            All Locations <ChevronDown size={14} data-id="element-2347" />
          </button>
          <Button icon={<Plus size={16} data-id="element-2349" />} data-id="element-2348">Add Employee</Button>
        </div>
      </div>

      <OperationsSwitcher data-id="element-2350" />

      <TabNavigation tabs={TEAM_TABS} basePath="/operations/team" data-id="element-2351" />

      {/* Schedule Grid */}
      <Card className="overflow-hidden" noPadding data-id="element-2352">
        <div className="overflow-x-auto" data-id="element-2353">
          <table className="w-full text-sm border-collapse" data-id="element-2354">
            <thead data-id="element-2355">
              <tr className="bg-background-elevated border-b border-white/10" data-id="element-2356">
                <th className="p-4 text-left font-medium text-text-secondary w-48 sticky left-0 bg-background-elevated z-10" data-id="element-2357">
                  EMPLOYEE
                </th>
                {DAYS.map(day => <th key={day} className="p-4 text-center font-medium text-text-secondary min-w-[100px] border-l border-white/5" data-id="element-2358">
                    <div className="flex flex-col" data-id="element-2359">
                      <span className="text-xs uppercase" data-id="element-2360">
                        {day.split(' ')[0]}
                      </span>
                      <span className="text-text-primary" data-id="element-2361">
                        {day.split(' ')[1]}
                      </span>
                    </div>
                  </th>)}
                <th className="p-4 text-center font-medium text-text-secondary w-24 border-l border-white/5" data-id="element-2362">
                  HOURS
                </th>
                <th className="p-4 text-center font-medium text-text-secondary w-24 border-l border-white/5" data-id="element-2363">
                  ST 1
                </th>
                <th className="p-4 text-center font-medium text-text-secondary w-24 border-l border-white/5" data-id="element-2364">
                  ST 2
                </th>
                <th className="p-4 text-center font-medium text-text-secondary w-24 border-l border-white/5" data-id="element-2365">
                  ST 3
                </th>
              </tr>
            </thead>
            <tbody data-id="element-2366">
              {EMPLOYEES.map(emp => <tr key={emp.id} className="border-b border-white/5 hover:bg-white/5 transition-colors group" data-id="element-2367">
                  <td className="p-4 sticky left-0 bg-background-card group-hover:bg-background-elevated transition-colors z-10 border-r border-white/5" data-id="element-2368">
                    <div className="flex items-center gap-3" data-id="element-2369">
                      <div className={`w-8 h-8 rounded-full ${emp.color} flex items-center justify-center text-white text-xs font-bold`} data-id="element-2370">
                        {emp.initials}
                      </div>
                      <div data-id="element-2371">
                        <div className="font-medium text-text-primary" data-id="element-2372">
                          {emp.name}
                        </div>
                        <div className="text-xs text-text-secondary" data-id="element-2373">
                          {emp.role}
                        </div>
                      </div>
                    </div>
                  </td>
                  {emp.schedule.map((shift, i) => <td key={i} className="p-2 border-l border-white/5 h-16" data-id="element-2374">
                      <ShiftCell shift={shift} data-id="element-2375" />
                    </td>)}
                  <td className="p-4 text-center border-l border-white/5" data-id="element-2376">
                    <div className="font-medium" data-id="element-2377">{emp.hours}</div>
                    <div className="flex justify-center mt-1" data-id="element-2378">
                      {emp.status === 'ok' ? <Check size={14} className="text-accent-success" data-id="element-2379" /> : <AlertTriangle size={14} className="text-accent-warning" data-id="element-2380" />}
                    </div>
                  </td>
                  <td className="p-2 border-l border-white/5" data-id="element-2381">
                    <StationPill type={emp.schedule[0].station} data-id="element-2382" />
                  </td>
                  <td className="p-2 border-l border-white/5" data-id="element-2383">
                    <StationPill type={emp.schedule[1].station} data-id="element-2384" />
                  </td>
                  <td className="p-2 border-l border-white/5" data-id="element-2385">
                    <StationPill type={emp.schedule[2].station} data-id="element-2386" />
                  </td>
                </tr>)}

              {/* Staff Count Row */}
              <tr className="bg-background-elevated/50" data-id="element-2387">
                <td className="p-4 font-medium text-text-secondary sticky left-0 bg-background-elevated z-10 border-r border-white/5" data-id="element-2388">
                  STAFF COUNT
                </td>
                {STAFF_COUNTS.map((stat, i) => <td key={i} className="p-4 text-center border-l border-white/5" data-id="element-2389">
                    <div className={`flex items-center justify-center gap-1 font-bold ${stat.status === 'ok' ? 'text-accent-success' : 'text-accent-warning'}`} data-id="element-2390">
                      {stat.count}
                      {stat.status === 'ok' ? <Check size={14} data-id="element-2391" /> : <AlertTriangle size={14} data-id="element-2392" />}
                    </div>
                  </td>)}
                <td colSpan={4} className="border-l border-white/5" data-id="element-2393"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>

      {/* Leave Panel */}
      <Card className="bg-background-elevated/50 border-dashed" data-id="element-2394">
        <div className="flex items-center justify-between mb-4" data-id="element-2395">
          <h3 className="font-medium flex items-center gap-2" data-id="element-2396">
            <span data-id="element-2397">🏖️</span> LEAVE THIS WEEK
          </h3>
          <Button size="sm" variant="secondary" data-id="element-2398">
            Add Leave
          </Button>
        </div>
        <div className="space-y-2" data-id="element-2399">
          <div className="flex items-center gap-3 text-sm" data-id="element-2400">
            <span className="text-text-secondary w-24" data-id="element-2401">Dec 18</span>
            <span className="font-medium text-text-primary" data-id="element-2402">Ana P.</span>
            <span className="text-text-muted" data-id="element-2403">— Doctor appointment</span>
          </div>
          <div className="flex items-center gap-3 text-sm" data-id="element-2404">
            <span className="text-text-secondary w-24" data-id="element-2405">Dec 23-Jan 2</span>
            <span className="font-medium text-text-primary" data-id="element-2406">Stefan M.</span>
            <span className="text-text-muted" data-id="element-2407">— Vacation</span>
          </div>
        </div>
      </Card>
    </div>;
}